import { Injectable } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { AccountEnum } from 'libs/gb-front/account/feature/src/lib/gb-account.constants'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'
import { AuthFacade } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.facade'
import { GbFrontCookieService } from 'libs/gb-front/auth/util/src/lib/gb-front-cookie/gb-front-cookie.service'
import { Observable, of } from 'rxjs'
import { filter, map, take, tap } from 'rxjs/operators'
import * as AuthActions from 'libs/gb-front/auth/data-access/src/lib/+state/auth.actions'

/**
 * Guard to manage access to /vol login:
 * - If user is a logged-in volunteer, redirects to account page.
 * - If user is a logged-in guest, logs them out and allows access.
 * - If user is not logged in, access is allowed.
 */
@Injectable({
  providedIn: 'root',
})
export class GbVolLoginGuard {
  constructor(
    private gbFrontCookieService: GbFrontCookieService,
    private auctionFacade: AuctionFacade,
    private authFacade: AuthFacade,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    if (this.gbFrontCookieService.isVolunteer()) {
      return this.auctionFacade.auctionUrlName$.pipe(
        map((urlName) => this.router.createUrlTree([urlName, AccountEnum.Account])),
      )
    } else if (this.gbFrontCookieService.isGuest()) {
      this.authFacade.dispatch(AuthActions.logout(false))

      return this.gbFrontCookieService.tokenCookie$.pipe(
        filter((token) => !token),
        take(1),
        map(() => true),
      )
    }
    return of(true)
  }
}
